angular.module('HomepageServices')
	.component('homepageMainContainer', require('./mainContainer.component'))
	.config(require('./mainContainer.config'));



// WEBPACK FOOTER //
// ./app/components/mainContainer/index.js